import { ChevronDown } from 'lucide-react';
import styles from './Accordion.module.scss';

interface AccordionProps {
  summary: string;
  children: React.ReactNode;
  testId: string;
}

export const Accordion: React.FC<AccordionProps> = ({ summary, children, testId }) => (
  <details className={styles.accordion} data-testid={testId}>
    <summary className={styles.summary} data-testid={`${testId}-summary`}>
      {summary}
      <span className={styles.icon} aria-hidden="true">
        <ChevronDown />
      </span>
    </summary>
    <div className={styles.content} data-testid={`${testId}-content`}>
      {children}
    </div>
  </details>
);
